module.exports = __webpack_public_path__ + "static/media/rw.f58a0d88.svg";